import { Link } from 'react-router-dom';
import { PATHS } from '../../../../constants/routes';
import Header from '../../../shared/Header/Header';
import Footer from '../../../shared/Footer/Footer';
import SectionHeader from '../../../layouts/showcaseLayouts/Section/SectionHeader/SectionHeader';
import BackButton from '../../../shared/backButton/BackButton';
import SectionBody from '../../../layouts/showcaseLayouts/Section/SectionBody/SectionBody';
import useIsLTE650 from '../../../../hooks/useIsLTE650';
import './aboutCompanyPage.scss';

const AboutCompanyPage: React.FC = () => {
    const isMobile = useIsLTE650(650);

    return (
        <div className="aboutCompanyPage">
            <Header isMobile={isMobile} />
            <div className="aboutCompanyPage__headerWrapper">
                <BackButton absolute />
                <SectionHeader title={'О компании'} />
            </div>
            <SectionBody>
                <>
                    {/* 1) Ч/б фото — первым, перед текстом */}
                    <section className="aboutCompanyPage__hero">
                        <img className="aboutCompanyPage__hero_img" src="/about-company/05.png" alt="Фабрика — архивное чёрно-белое фото" loading="eager" />
                    </section>

                    {/* Короткое приветствие */}
                    <section className="aboutCompanyPage__intro">
                        <p>Добро пожаловать в роскошный мир уюта и комфорта торгового дома С. Габай!</p>
                        <p>Мир, где история встречается с современностью, а качество становится философией.</p>
                    </section>

                    {/* 2) Абзац про историю + фото с женщиной справа */}
                    <section className="aboutCompanyPage__story">
                        <div className="aboutCompanyPage__story_text">
                            <p>
                                С.Габай – бренд с полуторавековой историей, начатой потомственным купцом Самуилом Садуковичем Габаем в 1864 году. Продукция фабрики
                                С.Габай отличалась отменным качеством, была отмечена на выставках в Лондоне и Париже в 19 веке, и сегодня мы стремимся
                                соответствовать высокому мастерству исполнения, возрождая наследие в новой реальности.
                            </p>
                        </div>
                        <figure className="aboutCompanyPage__story_media">
                            <img className="aboutCompanyPage__story_img" src="/about-company/06.jpg" alt="С.Gабай — современная коллекция" loading="lazy" />
                        </figure>
                    </section>

                    {/* Блок о коллекции и философии бренда */}
                    <section className="aboutCompanyPage__content">
                        <div className="aboutCompanyPage__content_group">
                            <p>В 2024 году под фамильной торговой маркой С. Габай представлены товары сегмента Premium home&living.</p>
                            <p>Это премиальные товары для дома и жизни, созданные с любовью к людям и вниманием к деталям.</p>
                            <p>
                                Мы предлагаем продукцию, которая не только отвечает самым высоким стандартам качества, но и привносит в вашу жизнь приятные эмоции,
                                даря ощущение комфорта и гармонии.
                            </p>
                        </div>

                        <p>
                            <b>Мы создаем вещи, чтобы Вы могли создать дом, достойный восхищения!</b>.
                        </p>

                        <div className="aboutCompanyPage__content_group">
                            <p>Коллекция 2025 называется «Территория сна».</p>
                            <p>Мы верим, что сон – это искусство, и собрали в ней товары, которые наполнят ваши ночи волшебными сновидениями.</p>
                            <p>В коллекции представлены одеяла, подушки и аксессуары из натурального 100% шелка премиум-класса.</p>

                            <Link className="aboutCompanyPage__link" to={PATHS.sleepTerritory} target="_blank" rel="noopener noreferrer">
                                Посмотреть коллекцию
                                <img className="luxuryArtPage__link_img" src="/icons/arrow-up-right.svg" alt="" />
                            </Link>
                        </div>
                    </section>
                </>
            </SectionBody>
            <Footer isMobile={isMobile} />
        </div>
    );
};

export default AboutCompanyPage;
